import * as React from "react";
const SvgFiRrOliveOil = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-olive-oil_svg__a)">
      <path
        fill="#062147"
        d="M19.211 12.32c4.205-2.912.264-9.264-4.211-6.77V3a3 3 0 0 0-3-3H8a1 1 0 0 0 0 2h1v6c0 .661-1.212 1.68-2.281 2.579C4.976 12.044 3 13.7 3 16c.089 3.525 3.167 8.02 6.732 8h4.536a5.06 5.06 0 0 0 3.758-1.7c2.48-2.5 4.547-7.019 1.185-9.98M17 7a2.01 2.01 0 0 1 .654 3.895A11.6 11.6 0 0 1 15.1 8.354 2.02 2.02 0 0 1 17 7m-6 1V2h1a1 1 0 0 1 1 1v5c-.041 1.955 2.447 3.563 4.031 5H6.969C8.554 11.563 11.041 9.955 11 8m5.536 12.967A3.06 3.06 0 0 1 14.268 22H9.732c-2.519.07-5.6-4.759-4.474-7h13.484c.892 2.2-.794 4.345-2.206 5.967"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-olive-oil_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOliveOil;
